// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1TRLJ","sendOtp":"AuthorizeToLogin_sendOtp__2KHlM"};